export default {
  item: null,
  loading: false
};
